import {
  I_ACCESS_TOKEN_PARAMS,
  I_COMMON_DELETE_PARAMS,
  I_COMMON_GET_ITEM_PARAMS,
  I_COMMON_CREATE_PARAMS,
  I_COMMON_PUT_PARAMS,
  I_COMMON_IMPORT_PARAMS,
  _customFetch,
  getFetchGETOptions,
  getFetchDELETEOptions,
} from './_base';
import LoggerService,{formatTrace} from '../../LoggerService';
import {I_CUSTOMER_REFERENTIAL_SITE} from '../interfaces/I_CUSTOMERS';
import APP_CONFIG from 'config';


// ---------------------------------
// --- Organismes ("audités")
// ---------------------------------

const ENDPOINT_CUSTOMERS = '/audited-customers';

const logger = LoggerService.getInstance();

interface I_GET_PARAMS extends I_ACCESS_TOKEN_PARAMS {
  type?: string;
  name?: string;
  id_customer?: string;
  referentiel_name?: string;
  referentiel_number?: string;
  mode?: string;  // 'light'
}
interface I_CUSTOMER_FIELDS {
  /** type : client ou organisme */
  type: string;
  /** nom du client / organisme */
  name: string;
  /** matricule de l'organisme (undefined si client) */
  id_customer?: number;
  /** liste des agréments de l'organisme (undefined si client) */
  referentials?: I_CUSTOMER_REFERENTIAL_SITE[];
}
interface I_CUSTOMER_POST_PARAMS extends I_COMMON_CREATE_PARAMS, I_CUSTOMER_FIELDS {}
interface I_CUSTOMER_PUT_PARAMS extends I_COMMON_PUT_PARAMS, I_CUSTOMER_FIELDS {}



/**
 * Requete le endpoint
 * Récupère la liste des organismes audités
 * @param param0
 */
const get = async ({accessToken,page,type,name,id_customer,referentiel_name,referentiel_number,mode}:I_GET_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - customers - get...'));
  const options = getFetchGETOptions({accessToken});
  const paramPage = `${page ? '&page=' + page : ''}`;
  const paramType = type ? `customer_type=${type}` : undefined;
  const paramName = name ? `name=${name}` : undefined;
  const paramID = id_customer ? `id_customer=${id_customer}` : undefined;
  const paramRefName = referentiel_name ? `referentiel_name=${referentiel_name}` : undefined;
  const paramRefNumber = referentiel_number ? `referentiel_number=${referentiel_number}` : undefined;
  const paramMode = mode ? `mode=${mode}` : undefined;
  const paramsAll = [paramType,paramName,paramID,paramRefName,paramRefNumber,paramMode].join('&');
  const URL = `${ENDPOINT_CUSTOMERS}${APP_CONFIG.ENDPOINT_SUFFIX}?${paramsAll}${paramPage}`;
  return _customFetch(URL,options);
};

/**
 * Requete le endpoint
 * Récupère l'organisme audité
 * @param param0
 * @returns
 */
const getItem = async ({accessToken,id}:I_COMMON_GET_ITEM_PARAMS) => {
  logger.trace(...formatTrace('ApiEndpoints - customers - getItem...'));
  const options = getFetchGETOptions({accessToken});
  const URL = `${ENDPOINT_CUSTOMERS}/${id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,options);
};

/**
 * Requete le endpoint  POST
 * Ajoute un organisme audité
 * @param param0
 * @returns
 */
export const post = async ({
  accessToken,
  type,name,id_customer,referentials,
}:I_CUSTOMER_POST_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - customers - post...'));
  const params = {
    method: 'POST',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
    body: JSON.stringify({
      customer_type: type,
      name: encodeURIComponent(name.trim()),
      id_customer,
      referentials,
  })
  };
  const URL = ENDPOINT_CUSTOMERS + APP_CONFIG.ENDPOINT_SUFFIX;
  return _customFetch(URL,params);
};

/**
 * Requete le endpoint  DELETE
 * Supprime un organisme audité
 * @param param0
 * @returns
 */
const remove = async ({accessToken,id}:I_COMMON_DELETE_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - customers - remove...'));
  const options = getFetchDELETEOptions({accessToken});
  const URL = `${ENDPOINT_CUSTOMERS}/${id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,options);
};

/**
 * Requete le endpoint PUT
 * Met à jour un organisme audité
 * @param param0
 * @returns
 */
const put = async ({
  accessToken,id,
  type,name,id_customer,referentials,
}:I_CUSTOMER_PUT_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - customers - put...'));
  const params = {
    method: 'PUT',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
    body: JSON.stringify({
      customer_type: type,
      name: encodeURIComponent(name.trim()),
      id_customer,
      referentials,
    })
  };
  const URL = `${ENDPOINT_CUSTOMERS}/${id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,params);
};


/**
 * Requete le endpoint POST file
 * Importe des organismes audités
 * @param param0
 * @returns
 */
const importList = async ({accessToken,file}:I_COMMON_IMPORT_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - customers - importList...'));
  const formData  = new FormData();
  formData.append("file",file,file.name);
  const params = {
    method: 'POST',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      // 'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
    body: formData,
  };
  const URL = `${ENDPOINT_CUSTOMERS}/import${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,params);
};

const CustomersEndpoints = {
  get,
  post,
  remove,
  put,
  getItem,
  importList,
};

export default CustomersEndpoints;
